<script setup lang="ts">
interface Props {
  status: 'success' | 'warning' | 'error';
}

defineProps<Props>();
</script>

<template>
  <div
    :class="[$style.root, $style[status]]"
    :data-status="status"
    data-testid="gophoto-upload-status"
    aria-hidden="true"
  >
    <svg
      :class="$style.icon"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      viewBox="0 0 24 24"
    >
      <path v-if="status === 'success'" d="m5 12 4.5 4.5L19 7"/>
      <template v-else-if="status === 'warning'">
        <circle cx="12" cy="12" r="8"/>
        <path d="M12 8.5v4.5m0 3h.01"/>
      </template>
      <path v-else d="M12 7v6m0 4h.01"/>
    </svg>
  </div>
</template>

<style module>
.root {
  --gophoto-upload-status-rgb: 76 175 80;

  display: grid;
  place-items: center;
  width: 6.25rem;
  aspect-ratio: 1;
  flex: none;
  margin-bottom: 2rem;
  border-radius: 50%;
  color: rgb(var(--gophoto-upload-status-rgb));
  background: rgb(var(--gophoto-upload-status-rgb) / 20%);
}

.warning {
  --gophoto-upload-status-rgb: 255 193 7;
}

.error {
  --gophoto-upload-status-rgb: 244 67 54;
}

.icon {
  width: 60%;
  height: 60%;
}
</style>
